import React from 'react';
import ProfileImage from '../../profileImage';

const TeamStaff = ({ teamMembers, startChat }) => {
  const staff = teamMembers.filter(m => m.accountType === 'supervisor');

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Coaching Staff ({staff.length})</h3>
      {staff.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <h4 className="text-lg font-medium text-gray-900 mb-2">No Staff Found</h4>
          <p className="text-gray-500">Coaching staff will appear here when assigned</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {staff.map((staffMember) => (
            <div key={staffMember._id} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center space-x-4 mb-4">
                <ProfileImage
                  image={staffMember.profilePicture}
                  alt={staffMember.userName}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900">@{staffMember.userName}</h4>
                  <p className="text-sm text-gray-500">{staffMember.title || 'Staff'}</p>
                  <p className="text-xs text-gray-400">
                    Joined {new Date(staffMember.joinDate).toLocaleDateString()}
                  </p>
                </div>
              </div>
              
              {staffMember.role && Object.keys(staffMember.role).length > 0 && (
                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700 mb-2">Permissions:</p>
                  <div className="space-y-1">
                    {Object.keys(staffMember.role).map((permission, index) => (
                      <span key={index} className="inline-block px-2 py-1 bg-orange-100 text-orange-800 rounded text-xs mr-2 mb-1">
                        {permission}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              <button
                onClick={() => startChat(staffMember)}
                className="w-full px-4 py-2 text-white rounded-lg hover:shadow-md transition-all duration-300 text-sm flex items-center justify-center space-x-2"
                style={{backgroundColor: '#e25820'}}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#d14d1a'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#e25820'}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
                </svg>
                <span>Chat with {staffMember.userName}</span>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamStaff; 